// frontend/admin-portal/src/components/dashboard/ProcurementSnapshot.jsx
import React from "react";
import { Alert, Spinner, Button,Panel } from "@fiberhome/shared-ui";
import { useNavigate } from "react-router-dom";

export default function ProcurementSnapshot({
  poSlice,
  rfqSlice,
  receiptSlice,
}) {
  const navigate = useNavigate();
  const po = poSlice;
  const rfq = rfqSlice;
  const receipts = receiptSlice;

  const tiles = [
    {
      num: rfq.data?.length ?? 0,
      label: "Pending RFQs",
      icon: "📄",
      cls: "primary",
      go: "/rfqs",
    },
    {
      num: po.data?.pending ?? 0,
      label: "Open POs",
      icon: "📦",
      cls: "warning",
      go: "/purchase-orders",
    },
    {
      num: po.data?.received ?? 0,
      label: "Received POs",
      icon: "✅",
      cls: "success",
      go: "/purchase-orders",
    },
    {
      num: receipts.data?.length ?? 0,
      label: "Pending Receipts",
      icon: "📥",
      cls: "purple",
      go: "/goods-receipts",
    },
  ];

  return (
    <Panel
      title="Procurement"
      subtitle="Open items in the pipeline"
      tone="purple"
      actions={
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate("/purchase-orders")}
        >
          Open POs →
        </Button>
      }
    >
      {po.loading || rfq.loading || receipts.loading ? (
        <div style={{ textAlign: "center", padding: "1rem 0" }}>
          <Spinner size="sm" />
        </div>
      ) : (
        <>
          {po.error && <Alert variant="danger">{po.error}</Alert>}
          {rfq.error && <Alert variant="danger">{rfq.error}</Alert>}
          {receipts.error && <Alert variant="danger">{receipts.error}</Alert>}

          <div className="fh-procurement-mini">
            {tiles.map((t) => (
              <div
                key={t.label}
                className={`fh-procurement-mini__tile fh-procurement-mini__tile--${t.cls}`}
                onClick={() => navigate(t.go)}
                role="button"
                tabIndex={0}
              >
                <div className="fh-procurement-mini__icon">{t.icon}</div>
                <div className="fh-procurement-mini__num">{t.num}</div>
                <div className="fh-procurement-mini__label">{t.label}</div>
              </div>
            ))}
          </div>
        </>
      )}
    </Panel>
  );
}
